// helpers
import dayjs from 'dayjs'
import isEmpty from 'lodash/isEmpty'

const DateCell: React.FC = (rawDate: string, record) => {
  const { key, ...rest } = record
  let date = ''

  if (isEmpty(rest)) return null

  if (!rawDate) date = 'N/A'
  else date = dayjs(rawDate).locale('es').format('DD MMM YYYY')


  const style = { display: 'flex', alignItems: 'center', justifyContent: 'start' }
  const props = {
    container: {
      style,
    }
  }

  return (
    <div {...props.container}>
      <div style={style}>
        {date}
      </div>
    </div>
  )
}

export default DateCell
